import { render } from "./ListeAuteurPage.vue?vue&type=template&id=c40bc744&ts=true"
import script from "./ListeAuteurPage.vue?vue&type=script&lang=ts"
export * from "./ListeAuteurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__